import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {
    AiAppEventRendererComponent
} from "../../../../../../../modules/ai/realtime/api/component/aiAppEventRenderer.component";
import {AiRealtimeAppEvent} from "../../../../../../../modules/ai/realtime/api/service/aiRealtime.service";
import {
    ChargedActConverter
} from "../../../../../../../modules/medical/charged-act/api/entity/converter/chargedAct.converter";
import {ChargedActModel} from "../../../../../../../modules/medical/charged-act/api/entity/chargedAct.model";
import {
    ConsultationChargedActItemComponent
} from "../consultation-charged-act-item/consultation-charged-act-item.component";

@Component({
    selector: 'app-charged-act-ai-event',
    standalone: true,
    imports: [ConsultationChargedActItemComponent],
    template: `
    <app-luna-consultation-charged-act-item
      [displayDate]="false"
      [entity]="chargedAct">
    </app-luna-consultation-charged-act-item>
  `,
})
export class ConsultationChargedActAiEventComponent implements AiAppEventRendererComponent, OnChanges {
    static readonly eventName = 'chargedAct';
    chargedAct: ChargedActModel;

    @Input() event!: AiRealtimeAppEvent;

    constructor(private chargedActConverter: ChargedActConverter) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.chargedAct = this.chargedActConverter.convert(this.event?.data);
    }
}
